import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IndexComponent } from './index/index.component';
import { InicioComponent } from './inicio/inicio.component';
import { SobreMiComponent } from './sobreMi/sobreMi.component';
import { MetodoDeTrabajoComponent } from './metodoDeTrabajo/metodoDeTrabajo.component';
import { AreasDeIntervencionComponent } from './areasDeIntervencion/areasDeIntervencion.component';
import { TalleresComponent } from './talleres/talleres.component';
import { ContactoComponent } from './contacto/contacto.component';
import { PsicoanecdotasComponent } from './psicoanecdotas/psicoanecdotas.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatMenuModule } from '@angular/material/menu';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    InicioComponent,
    SobreMiComponent,
    MetodoDeTrabajoComponent,
    AreasDeIntervencionComponent,
    TalleresComponent,
    ContactoComponent,
    PsicoanecdotasComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    NoopAnimationsModule,
    MatMenuModule,
    MatCardModule,
    NgbModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
